const originalFetch = require('isomorphic-fetch');
const fetch = require('fetch-retry')(originalFetch);

function getHeaders() {
    const headers = new Headers();
    headers.append("x-myselfly-api-key", process.env.REACT_APP_API_KEY);
    headers.append("Content-Type", "application/json");
    return headers;
}

export async function sendConsumerResponse(consumerResponseObj) {
    const url = `${process.env.REACT_APP_API_URL}/v3/consumer-feedback`
    // make sure we have this field not null
    if (!consumerResponseObj.timestamp) consumerResponseObj.timestamp = Math.floor(new Date().getTime() / 1000);

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(consumerResponseObj),
        headers: getHeaders()
    }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    });
}

export async function fetchOrderById(orderId) {
    const url = `${process.env.REACT_APP_API_URL}/v3/transaction-e-receipt/${orderId}`

    return fetch(url, { headers: getHeaders() }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    });
}

export async function fetchOrderByTime(timestamp, deviceCode) {
    const url = `${process.env.REACT_APP_API_URL}/v3/transaction-e-receipt?timestamp=${timestamp}&deviceCode=${deviceCode}`

    return fetch(url, {
        headers: getHeaders(),
        retries: 8,
        retryOn: [404],
        retryDelay: 7500
    }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    });
}